<template>
  <v-tabs class="categories-container" show-arrows>
    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
    <v-tab
      v-for="(category, index) in categories"
      :key="index"
      @click="selectCategory(category)"
      >{{ category.name[lang] }}</v-tab
    >
  </v-tabs>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: ["categories"],
  data: () => {
    return {
      lang: window.appLocale,
    };
  },
  methods: {
    ...mapMutations({
      selectCategory: "selectCategory",
    }),
  },
  created(){
    this.selectCategory(this.categories[0])
  }
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.categories-container {
  margin-top: 35px;

  @media (min-width: 1024px) {
    margin-top: 70px;
  }

  .v-tabs-slider {
    color: $primary;
  }
  .v-tabs-bar {
    background: transparent !important;
    .v-tab {
      padding: 0 1rem;
      text-transform: none;
      font-family: 'Space Grotesk', sans-serif;
      color: $black !important;
      min-width: unset;
      font-size: 20px;
      color: $rouge !important;

      + .v-tab {
        margin-left: 1.3rem;
      }
    }
  }
}
.v-slide-group__prev,
.v-slide-group__next{
  @media(min-width: 1280px){
    display: none !important;
  }
  @media(max-width: 500px){
    display: none !important;
  }
}
.v-slide-group__prev i,
.v-slide-group__next i{
    color: $rouge !important;
}

.v-slide-group__content {
    justify-content: center;
}
</style>
